exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-login-form-box[data-v-fe892c2e] {\n  width: 460px;\n  border: 1px solid #d6d6d6;\n  padding: 30px;\n  margin-top: 50px;\n  background-color: #DDEAFA;\n}\n.h-login-form-box h3[data-v-fe892c2e] {\n  text-align: center;\n  margin-bottom: 20px;\n}\n.h-login-form-no-acc[data-v-fe892c2e] {\n  margin-top: 15px;\n}\n.h-order-form-box h3[data-v-fe892c2e] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
